// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Emotion from "../../bindings/Emotion.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function getVariantStyles(variant) {
  if (variant === "default") {
    return Emotion.Css.css({
      backgroundColor: Emotion.Utils.Color.bgSecondary,
      border: `1px solid ` + Emotion.Utils.Color.border,
      borderRadius: Emotion.Utils.Border.getRadius("md")
    });
  } else if (variant === "outlined") {
    return Emotion.Css.css({
      backgroundColor: "transparent",
      border: `2px solid ` + Emotion.Utils.Color.border,
      borderRadius: Emotion.Utils.Border.getRadius("md")
    });
  } else {
    return Emotion.Css.css({
      backgroundColor: "transparent",
      border: "none",
      borderBottom: `2px solid ` + Emotion.Utils.Color.border,
      borderRadius: "0",
      paddingLeft: "0"
    });
  }
}

function Select$Select(props) {
  let __className = props.className;
  let __disabled = props.disabled;
  let __variant = props.variant;
  let placeholder = props.placeholder;
  let variant = __variant !== undefined ? __variant : "default";
  let disabled = __disabled !== undefined ? __disabled : false;
  let className = __className !== undefined ? __className : "";
  let selectClassName = Emotion.Css.cx([
    Emotion.Css.css({
      width: "100%",
      height: "2.5rem",
      padding: "0 0.75rem",
      fontFamily: "inherit",
      fontSize: "1rem",
      color: Emotion.Utils.Color.textPrimary,
      outline: "none",
      appearance: "none",
      backgroundImage: `linear-gradient(45deg, transparent 50%, ` + Emotion.Utils.Color.textSecondary + ` 50%), linear-gradient(135deg, ` + Emotion.Utils.Color.textSecondary + ` 50%, transparent 50%)`,
      backgroundPosition: "calc(100% - 1.1rem) 1.05rem, calc(100% - 0.75rem) 1.05rem",
      backgroundSize: "0.35rem 0.35rem, 0.35rem 0.35rem",
      backgroundRepeat: "no-repeat",
      cursor: "pointer",
      ":focus": {
        borderColor: Emotion.Utils.Color.primary,
        boxShadow: Emotion.Utils.Shadow.getFocusShadow("primary")
      }
    }),
    getVariantStyles(variant),
    disabled ? Emotion.Css.css({
        opacity: "0.5",
        cursor: "not-allowed"
      }) : "",
    className
  ]);
  return JsxRuntime.jsxs("select", {
    children: [
      placeholder !== undefined ? JsxRuntime.jsx("option", {
          children: placeholder,
          disabled: true,
          value: ""
        }) : null,
      props.options.map(choice => JsxRuntime.jsx("option", {
        children: choice.label,
        value: choice.value
      }, choice.value))
    ],
    "aria-label": props.ariaLabel,
    className: selectClassName,
    id: props.id,
    disabled: disabled,
    name: props.name,
    value: props.value,
    onChange: props.onChange
  });
}

let Select = {
  getVariantStyles: getVariantStyles,
  make: Select$Select
};

export {
  Select,
}
/* Emotion Not a pure module */
